export enum BusinessType {
  Derivatives = 1,
  Insurance = 2
}
